import { hydrate } from "svelte";
import { islandsOptions, navigatorOptions } from "@kestrel/client";
import type { SSRData } from "@kestrel/template";
import Root from "./root.svelte";
import { resolveComponentFromRouteId } from "./component/resolve";
import { createStores } from "./stores";
import { ssrDataAttribute } from "../../utils/consts";
import { initNavigator } from "./navigator/init.js";
import { getComponentUpdater } from "./navigator/component";
import { noop } from "../../utils/function";
import {
  hydrateIslandsIfAllRegistered,
  propagateIslandsFromEntrypoint,
  registerIslandEntrypoint,
} from "./component/islands";

export type BootstrapOptions = {
  /**
 *
 */
  id: string;
  /**
 *
 */
  app: string;
};

/**
 *
 */
export const add = islandsOptions ? registerIslandEntrypoint : noop;

/**
 *
 *
 *
 *
 */
export async function start(current: HTMLScriptElement, { id }: BootstrapOptions): Promise<void> {
  const container = current.parentElement;
  if (!container && import.meta.env.DEV) {
    throw new Error("current script element is not attached to a parent");
  }

  const dataElement = container!.querySelector<HTMLScriptElement>(
    `script[type='application/json'][${ssrDataAttribute}='${id}']`,
  );

  if (!dataElement && import.meta.env.DEV) {
    throw new Error("No data element found in container");
  }

  const { textContent } = dataElement!;
  if (!textContent && import.meta.env.DEV) {
    throw new Error("Data element does not contains ssr state");
  }

  const ssrState = JSON.parse(textContent!) as SSRData;
  if (!ssrState.routeId && !ssrState.error && import.meta.env.DEV) {
    throw new Error("Invalid ssr state, missing routeId");
  }

  /*                                              */
  const resolvedComponent = await resolveComponentFromRouteId(ssrState.routeId, ssrState.error);
  const [component] = resolvedComponent;

  /*                                                */
  /*                                                             */
  const stores = createStores(ssrState, resolvedComponent);

  /*                                                                                */
  if (!islandsOptions) hydrate(Root, { target: container!, props: { component, stores } });

  /*                                                                              */
  if (islandsOptions) {
    propagateIslandsFromEntrypoint(current);
    hydrateIslandsIfAllRegistered(stores, ssrState, resolvedComponent);
  }

  /*                                         */
  if (navigatorOptions) {
    /*                                        */
    stores.navigate.subscribe(getComponentUpdater(stores));

    /*                                        */
    initNavigator(stores);
  }
}
